"use client"

import NumberFlow from "@number-flow/react"

type StatCounterProps = {
  value: number
  suffix?: string
  prefix?: string
  decimals?: number
  className?: string
}

export function StatCounter({
  value,
  suffix = "",
  prefix = "",
  decimals = 0,
  className,
}: StatCounterProps) {
  return (
    <span className={className}>
      {prefix}
      <NumberFlow value={value} format={{ maximumFractionDigits: decimals }} />
      {suffix}
    </span>
  )
}
